<app-selector label="Branches" [data]="branchesCoreService.branchesList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="branchesCoreService.loading" [hint]="hint">
</app-selector>
